import { render, staticRenderFns } from "./ChatWindow.vue?vue&type=template&id=70f90043&scoped=true"
import script from "./ChatWindow.vue?vue&type=script&lang=js"
export * from "./ChatWindow.vue?vue&type=script&lang=js"
import style0 from "./ChatWindow.vue?vue&type=style&index=0&id=70f90043&prod&scoped=true&lang=scss"
import style1 from "./ChatWindow.vue?vue&type=style&index=1&id=70f90043&prod&lang=scss"
import style2 from "./ChatWindow.vue?vue&type=style&index=2&id=70f90043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70f90043",
  null
  
)

export default component.exports